<template>
  <div class="index_contain">
    <div class="index_head">
      <div class="text_center">您好，欢迎进入MeTeLVIP申请系统</div>
      <div class="index_register text_center">
          <van-button round type="info" size="large" @click="registerLink()">
            <span style="font-size:1.3rem">注册账号</span>
          </van-button>
      </div>
      <div class="text_center" style="font-size:1rem;">
        已有账号
        <span class="color_FFC107 text-underline" @click="loginLink()" style="cursor:pointer">登录</span>
      </div>

      <div class="index_main">
        <div class="index_mian_title color_555">VIP用户权益说明：</div>
        <div class="color_999 font-1">1 享有普通注册用户的一切权益。</div>
        <div
          class="color_999 font-1"
        >2 可免费使用国道数据授权产品-MeTeL多媒体教学资源库， 且用户权限级别高于普通授权用户，如每日查看课程数量， 每日下载资源数量等。</div>
        <div class="color_999 font-1">3 查看全学科课程及教学资源，超IP访问，享受平台内VIP 特权功能及服务。</div>
        <div class="text_center">
          <img src="@/assets/imgs/METEL_QRCODE@2x.png" alt srcset class="index_metel_imgcode" />
        </div>
        <div class="color_666 text_center font-1">关注“密泰尔学堂”开启MeTeL移动端学习之旅</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods:{
      loginLink(){
          let client_id = 'b950b269-57fd-43ec-bfed-7d0701288e47';
          let redirect_uri = window.location.origin+'/back';
          window.location= 'https://passport.guodao.cn/login?response_type=code&client_id='+client_id+'&redirect_uri='+redirect_uri;
      },
      // ?response_type=code&client_id=0fbb1d00-a885-4c2f-85fc-76c410c0471f&redirect=http://metel.cn/loginback
      registerLink(){
          let client_id = 'b950b269-57fd-43ec-bfed-7d0701288e47';
          let redirect_uri = window.location.origin+'/back';
          window.location= 'https://passport.guodao.cn/register?response_type=code&client_id='+client_id+'&redirect_uri='+redirect_uri;
      }
  }
};
</script>
<style scoped>
.index_contain {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.index_head {
  width: 100%;
  height: 40vh;
  color: #ffffff;
  font-size: 18px;
  font-weight: 400;
  line-height: 36px;
  padding-top: 4rem;
  font-size: 1.3rem;
  position: relative;
  background: linear-gradient(90deg, #319cc4 0%, #317bd2 50%, #6471d0 100%);
}
.color_FFC107 {
  color: #ffc107;
}
.index_register {
  margin: 1rem;
}
.index_main {
  background: #ffffff;
  padding: 1rem;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  position: absolute;
  top: 18rem;
  left: 5vw;
  right: 5vw;
  padding-top: 2rem;
}
.index_metel_imgcode {
  height: 10rem;
}
.index_main > div {
  line-height: 2rem;
  font-weight: 400;
  margin-top: 1rem;
}
.index_main:last-child {
  padding-bottom: 3rem;
}
.index_mian_title {
  font-size: 1.5rem;
  font-weight: bold;
}
.color_555 {
  color: #555555;
}
.color_999 {
  color: #999999;
}
.color_666 {
  color: #666666;
}
.text_center {
  text-align: center;
}
.font-1 {
  font-size: 1rem;
}
.text-underline {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue